"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DmsAnalytics = void 0;
var amplitude_js_1 = __importDefault(require("amplitude-js"));
var DmsAnalytics = /** @class */ (function () {
    function DmsAnalytics(apiKey, userId) {
        if (apiKey && apiKey !== '' && amplitude_js_1.default) {
            this.amplitude = amplitude_js_1.default.getInstance();
            this.amplitude.init(apiKey);
            if (userId && userId !== '') {
                this.amplitude.setUserId(userId);
            }
        }
        else {
            if (apiKey && apiKey !== '') {
                console.error("API key is required to initilize Amplitude");
            }
        }
    }
    DmsAnalytics.prototype.track = function (event, data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.amplitude.logEvent(event, data);
                resolve('success');
            }
            catch (e) {
                reject(new Error("something went wrong try again later"));
            }
        });
    };
    DmsAnalytics.prototype.setUserId = function (userId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.amplitude.setUserId(userId);
                resolve('success');
            }
            catch (e) {
                reject(new Error("something went wrong try again later"));
            }
        });
    };
    DmsAnalytics.prototype.identify = function (userProps) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var identifyObj_1 = new _this.amplitude.Identify();
                Object.keys(userProps).forEach((function (key) { return identifyObj_1.set(key, userProps[key]); }));
                _this.amplitude.identify(identifyObj_1);
                resolve('success');
            }
            catch (e) {
                reject(new Error("something went wrong try again later"));
            }
        });
    };
    return DmsAnalytics;
}());
exports.DmsAnalytics = DmsAnalytics;
